import TaxReportRepository from "@adapters/repositories/Reports/TaxReport";
import { accountDetails } from "@di";
import { downloadReportsRepo } from "@frameworks/web/components/Reports/understandingCommonDI/downloadReportsDI";
export default (http, infrastructure) => {
    return {
        taxMainScreenRepo: new TaxReportRepository(http, accountDetails),
        downloadRepo: downloadReportsRepo,
    };
};
